import script from "./TheHumberger.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHumberger.vue?vue&type=script&setup=true&lang=js"

import "./TheHumberger.vue?vue&type=style&index=0&id=2384350e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2384350e"]])

export default __exports__